(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    class DDMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.closeTimeout = null;

      if (!this.details || !this.summary) return;

      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    clearCloseTimeout() {
      if (this.closeTimeout) {
        window.clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    }

    openMenu() {
      this.clearCloseTimeout();
      DDMegaMenu.closeAllExcept(this);
      this.details.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }

    scheduleClose() {
      this.clearCloseTimeout();
      this.closeTimeout = window.setTimeout(() => {
        this.closeMenu();
      }, 200);
    }

    closeMenu() {
      this.clearCloseTimeout();
      this.details.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');
    }

    // Alias so <sticky-header>'s closeMenuDisclosure() (which calls
    // .close() on every <dd-mega-menu>) also closes this component.
    close() {
      this.closeMenu();
    }

    onMouseEnter() {
      if (window.matchMedia('(hover: hover)').matches) {
        this.openMenu();
      }
    }

    onMouseLeave() {
      if (window.matchMedia('(hover: hover)').matches) {
        this.scheduleClose();
      }
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.details.hasAttribute('open')) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    }

    onKeyUp(event) {
      if (event.code === 'Escape') {
        this.closeMenu();
        this.summary.focus();
      }
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget)) {
        this.closeMenu();
      }
    }

    static closeAllExcept(current) {
      document.querySelectorAll('dd-mega-menu').forEach((menu) => {
        if (menu !== current) menu.closeMenu();
      });
    }
  }

  if (!customElements.get('dd-mega-menu')) {
    customElements.define('dd-mega-menu', DDMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
